import ScanDocument from './ScanDocument';

export default ScanDocument;
